import { memo } from 'react'
import { useArticleContext } from '../../_core'
import { styled, theme } from 'twin.macro'
import Callout from '@components/DesignSystem/Callout'
import { useTranslation } from '@i18n'
import useContentInputFeatureToggle from './useContentInputFeatureToggle'

function ContentInputContainer() {
  const { t } = useTranslation('editor')

  const {
    articleState: {
      content,
      publish: { warnings, timestamp, action },
    },
  } = useArticleContext()

  const ContentInput = useContentInputFeatureToggle()

  return (
    <>
      <ContentInput initialValue={content} />
      {warnings?.contentRequired && (
        <ContentCallout
          key={timestamp}
          title={t('warnings.contentRequired.title')}
          message={t(`warnings.contentRequired.message.${action}`)}
        />
      )}
    </>
  )
}

export default memo(ContentInputContainer)

const ContentCallout = styled(Callout)`
  @media (min-width: ${theme`screens.md`}) {
    display: inline-flex;
    margin-top: -300px;
  }
`
